import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { PROMOTION_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { PromoItemListPage } from '@/features/promotion/pages/PromoItemListPage';
import { promoItemSearchSchema } from '@/features/promotion/types/promotion.types';

export const Route = createFileRoute('/_auth/promotion/items')({
  beforeLoad: () => requirePermission(PROMOTION_PERMISSIONS.ITEM_LIST_VIEW),
  validateSearch: promoItemSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Promotional Item List">
      <Suspense fallback={<PageLoader />}>
        <PromoItemListPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
